import "https://cdn.jsdelivr.net/gh/orestbida/cookieconsent@v3.0.0-rc.17/dist/cookieconsent.umd.js";

CookieConsent.run({
  guiOptions: {
    consentModal: {
      layout: "box",
      position: "middle center",
      equalWeightButtons: true,
      flipButtons: false,
    },
    preferencesModal: {
      layout: "box",
      position: "right",
      equalWeightButtons: true,
      flipButtons: false,
    },
  },
  categories: {
    necessary: {
      readOnly: true,
    },
    functionality: {},
    analytics: {},
    marketing: {},
  },
  language: {
    default: "de",
    autoDetect: "document",
    translations: {
      en: {
        consentModal: {
          title:
            "Cookie Dashboard <img style='width: 40px;float: right;' src='https://www.loewenanteil.com/cdn/shop/files/LowenanteilLogo1_100x.png?v=1613610178'/>",
          description:
            'By clicking "agree", you agree that we may track your use of our platform through cookies (from Löwenanteil and third parties) to analyze and personalize your user experience and advertisements displayed to you.\n\t\t<div id="cc-custom-list-type"><p>Essential</p><p>Statistics</p><p>Marketing</p></div>\n\t\t',
          acceptAllBtn: "Accept all",
          showPreferencesBtn: "Change Settings",
        },
        preferencesModal: {
          title: "Consent Preferences Center",
          acceptAllBtn: "Accept all",
          savePreferencesBtn: "Save preferences",
          closeIconLabel: "Close modal",
          serviceCounterLabel: "Service|Services",
          sections: [
            {
              title: "Cookie Usage",
              description:
                'By clicking "agree", you agree that we may track your use of our platform through cookies (from Löwenanteil and third parties) to analyze and personalize your user experience and advertisements displayed to you.',
            },
            {
              title: 'Essential',
              description:
                "Löwenanteil needs these cookies to function as a website. That's why they can't be turned off - without basic cookies, nothing works here. They ensure that you are safe and comfortable on Löwenanteil.",
              linkedCategory: "necessary",
            },
            {
              title: "Statistics",
              description:
                "Statistics cookies help website owners understand how visitors interact with websites by collecting and reporting information anonymously.",
              linkedCategory: "analytics",
            },
            {
              title: "Marketing",
              description:
                "These cookies give us important information about the behavior of our visitors. They collect information about what interests users the most on Löwenanteil or which pages are used most frequently. This allows us to tailor Löwenanteil to the needs of our customers. We also collect this data anonymously. We only want to show you ads that are of interest to you. That's why we use cookies that record your search criteria and ensure that you see bowls that are relevant to you on <a href='https://www.facebook.com/privacy/policy/?entry_point=data_policy_redirect&entry=0'>Facebook</a> or <a href='https://business.safety.google/intl/de/privacy/</a>",
              linkedCategory: "marketing",
            },
            {
              title: "More information",
              description:
                'For any queries in relation to our policy on cookies and your choices, please <a class="cc__link" href="#https://www.loewenanteil.com/pages/kontakt">contact us</a>.',
            },
          ],
        },
      },
      de: {
        consentModal: {
          title:
            "Cookie Dashboard <img style='width: 40px;float: right;' src='https://www.loewenanteil.com/cdn/shop/files/LowenanteilLogo1_100x.png?v=1613610178'/>",
          description:
            'Mit Klick auf "Einverstanden" stimmst Du zu, dass wir Deine Nutzung unserer Plattform durch Cookies (von Löwenanteil und Dritten) nachverfolgen, um Deine Nutzungserfahrung und Dir angezeigte Werbung zu analysieren und personalisieren.',
          acceptAllBtn: "Einverstanden",
          showPreferencesBtn: "Einstellungen anpassen",
          footer: "Mehr Erfahren: <a href=\'https://business.safety.google/intl/de/privacy/'> Google Datenschutzerklärung & Nutzungsbedingungen</a>"
        },
        preferencesModal: {
          title: "Präferenzen für die Zustimmung",
          acceptAllBtn: "Alle akzeptieren",
          savePreferencesBtn: "Speichern & schließen",
          closeIconLabel: "Modal schließen",
          serviceCounterLabel: "Dienstleistungen",
          sections: [
            {
              title: "Verwendung von Cookies",
              description:
                'Mit Klick auf "Alle akzeptieren" stimmst Du zu, dass wir Deine Nutzung unserer Plattform durch Cookies (von Löwenanteil und Dritten) nachverfolgen, um Deine Nutzungserfahrung und Dir angezeigte Werbung zu analysieren und personalisieren.',
            },
            {
              title: 'Essential',
              description:
                "Diese Cookies braucht Löwenanteil, um als Website zu funktionieren. Deshalb können sie auch nicht abgeschaltet werden – ohne Basiscookies geht hier schlichtweg nichts. Sie sorgen dafür, dass Du auf Löwenanteil sicher und bequem unterwegs bist.",
              linkedCategory: "necessary",
            },
            {
              title: "Statistik",
              description:
                "Statistik-Cookies helfen Webseiten-Besitzern zu verstehen, wie Besucher mit Webseiten interagieren, indem Informationen anonym gesammelt und gemeldet werden.",
              linkedCategory: "analytics",
            },
            {
              title: "Marketing",
              description:
                'Diese Cookies geben uns wichtige Hinweise zum Verhalten unserer Besucher. Sie sammeln Informationen darüber, was User auf Löwenanteil am meisten interessiert oder welche Seiten am häufigsten genutzt werden. So können wir Löwenanteil auf die Bedürfnisse unserer Kunden ausrichten. Auch diese Daten erheben wir anonym. Wir wollen Dir nur Anzeigen präsentieren, die Dich auch interessieren. Deshalb verwenden wir Cookies, die Deine Suchkriterien erfassen und dafür sorgen, dass Du auf <a class="cc-link" href="https://www.facebook.com/privacy/policy/?entry_point=data_policy_redirect&entry=0">Facebook</a> oder <a class="cc-link" href="https://policies.google.com/privacy?hl=de">Google</a>  Produkte siehst, die zu Dir passen.',
              linkedCategory: "marketing",
            },
            {
              title: "Mehr Informationen",
              description:
                'Bei Fragen zu unserer Richtlinie, zu Cookies und Deinen Auswahlmöglichkeiten <a class="cc-link" href="https://www.loewenanteil.com/pages/kontakt">kontaktiere uns</a> gerne oder informieren Dich über unsere <a class="cc-link" href="https://www.loewenanteil.com/policies/privacy-policy">Datenschutzrichtlinien</a>.',
            },
          ],
        },
      },
    },
  },
  disablePageInteraction: true,
  onConsent: ({cookie}) => {
    let gtagConsentConfig = {};
    if (cookie.categories.includes('necessary') && cookie.categories.includes('functionality') && cookie.categories.includes('analytics') && cookie.categories.includes('marketing')) {
        gtagConsentConfig = {
            'ad_storage': 'granted',
            'analytics_storage': 'granted',
            'functionality_storage': 'granted',
            'ad_personalization': 'granted',
            'ad_user_data': 'granted'
        };
    } else if (cookie.categories.length === 1 && cookie.categories.includes('necessary')) {
        gtagConsentConfig = {
            'functionality_storage': 'granted'
        };
    } else if (cookie.categories.includes('necessary') && categories.includes('analytics') && cookie.categories.length === 2) {
        gtagConsentConfig = {
            'functionality_storage': 'granted',
            'analytics_storage': 'granted'
        };
    }
    else if (cookie.categories.includes('necessary') && categories.includes('marketing') && cookie.categories.length === 2) {
        gtagConsentConfig = {
            'functionality_storage': 'granted',
            'ad_storage': 'granted',
            'ad_personalization': 'granted',
            'ad_user_data': 'granted'
        };
    }
    else if (cookie.categories.length === 3) {
gtagConsentConfig = {
            'ad_storage': 'granted',
            'analytics_storage': 'granted',
            'functionality_storage': 'granted',
            'ad_personalization': 'granted',
            'ad_user_data': 'granted'
        };
    }

    gtag('consent', 'update', gtagConsentConfig);
    }
});